import React, { useState, useEffect } from 'react';
import { PartnerService } from '../service/PartnerService';

const partnerService = new PartnerService();

export default function PartnerImage({ partnerId, type = 'image', width, height, style, className, onClick, refresh }) {
    const [src, setSrc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setSrc(null);
        partnerService.getPartnerImage(partnerId, type)
            .then(base64 => {
                if (cancelled) return;
                setSrc(base64 ? `data:image/jpeg;base64,${base64}` : null);
                setLoading(false);
            })
            .catch(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; };
    }, [partnerId, type, refresh]);

    if (loading) return <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.2rem', color: '#aaa' }} />;
    if (!src) return null;

    return (
        <img
            src={src}
            alt=""
            width={width}
            height={height}
            className={className}
            style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
            onClick={() => onClick && onClick(src)}
        />
    );
}
